"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickLabel = void 0;
var ClickLabel;
(function (ClickLabel) {
    ClickLabel["DETAILS"] = "DETAILS";
    ClickLabel["DOWNLOAD"] = "DOWNLOAD";
    ClickLabel["FAVORITE"] = "FAVORITE";
    ClickLabel["RELATED_VIDEO"] = "RELATED_VIDEO";
})(ClickLabel = exports.ClickLabel || (exports.ClickLabel = {}));
//# sourceMappingURL=ClickLabelEnum.js.map